// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1411":"9b58966f","2146":"9b58966f","2414":"1de13a87","6384":"bef3f8b1"}[chunkId] + ".chunk.css";
};